<div class="row mt-3 mr-1 ml-1">
	<div class="col-md-12" align="center">
		<h3> Combinatorics 2024 REGISTRATION </h3>
	</div>
</div>
<div class="row mt-3 mr-1 ml-1">
	<div class="col-md-12">
		<p style="color: red; text-align: center;">
			<b> Registration closed on the 07/05/2024. </b>
		</p>

		<p>
			The fee of combinatorics2024 is:
		</p>
		<ol>
			<li>
				300.00 euros, full early registration;
			</li>

			<li>
				275.00 euros, full early registration fee for De Cifris members;
			</li>

			<li>
				250.00 euros, student early registration fee; <br>
				(Fee reserved to PhD students and postdoc researchers who obtained their PhD after June 2022)
			</li>

			<li>
				240.00 euros, student early registration fee for De Cifris members;
			</li>

			<li>
				350 euros, full late registration fee;
			</li>

			<li>
				325.00 euros, full late registration fee for De Cifris members;
			</li>

			<li>
				300.00 euros, student late registration fee;
			</li>

			<li>
				290.00 euros, student late registration fee for De Cifris members;
			</li>

			<li>
				170.00 euros, accompanying person.
			</li>
		</ol>

		<h4> Deadlines </h4>
		<ul>
			<li>Early registration payment <b>24/02/2024</b></li>

			<li>Late registration payment <b>07/05/2024</b></li>
		</ul>

		<p>
			<b>NB:</b> Students from the Polytechnic University of Bari can attend for free.
		</p>
		<p>
			Unfortunately, there is a limited number of places due to the hosting structure. Registrations will
			close
			when this number is reached or at latest on May 7th 2024. <br>
			If you are Italian or another European Union citizen, we strongly encourage you to become a member of De
			Cifris, since its membership costs only 20 euros or 5 euros (depending on your age), and it gives you a
			significant discount on the fees. To become a member, just follow these instructions: <a
				href="https://www.decifris.it/associarsi">
				https://www.decifris.it/associarsi
			</a>.
		</p>
		<div style="color: red;">
			<p>
				To register for Combinatorics 2024, please:
			</p>
			<ol>
				<li>
					Send an email to <a href="mailto:combinatorics2024@decifris.it">
						combinatorics2024&#64;decifris.it
					</a> with your name and your affiliation as subject (for example, "Albert Turing, University of
					Trento"). <br>
					In the email please specify whether you pay yourself or your company/institution pays for you
					(in that case, please send us its fiscal data).
				</li>

				<li>
					EITHER pay with your bank, following the instruction in your email reply; <br>
					OR pay via credit card filling the form below.
				</li>
			</ol>
		</div>
	</div>
</div>
<div class="row mt-3 mr-1 ml-1">
	<div class="col-md-12">
		<h4>PAYMENT</h4>
	</div>
	<form id="payForm" class="form" method="post" (submit)="checkAndPay()">
		<label> Fee </label>
		<div>
			<input type="radio" id="regular_late" name="fee" value="35000" (click)=setFee($event) checked="checked">
			<label for="regular_late">
				Full Late registration
			</label><br>

			<input type="radio" id="regular_late_DC" name="fee" value="32500" (click)=setFee($event)>
			<label for="regular_late_DC">
				Full Late registration (for De Cifris members)
			</label><br>

			<input type="radio" id="student_late" name="fee" value="30000" (click)=setFee($event)>
			<label for="student_late">
				Student Late registration
			</label><br>

			<input type="radio" id="student_late_DC" name="fee" value="29000" (click)=setFee($event)>
			<label for="student_late_DC">
				Student Late registration (for De Cifris members)
			</label><br>

			<input type="radio" id="companion" name="fee" value="17000" (click)=setFee($event)>
			<label for="companion"> Accompanying person </label>
		</div>

		<!-- Hidden input -->
		<input type="hidden" id="alias" name="alias" value={{ALIAS}}>
		<input type="hidden" id="importo" name="importo">
		<input type="hidden" id="divisa" name="divisa" value={{DIVISA}}>
		<input type="hidden" id="codTrans" name="codTrans">
		<input type="hidden" id="url" name="url">
		<input type="hidden" id="url_back" name="url_back">
		<input type="hidden" id="mac" name="mac">
		<input type="hidden" id="mail" name="mail">
		<input type="hidden" id="languageId" name="languageId" value="ENG">
		<input type="hidden" id="descrizione" name="descrizione">
		<input type="hidden" id="Note1" name="Note1" value="Enrollment for combinatorics2024.">
		<input type="hidden" id="nome" name="nome">
		<input type="hidden" id="cognome" name="cognome">

		<hr><!---------------------------------------------------------------->

		<p style="font-weight: bold;">
			Total: € {{fee/100}}.00
		</p>

		<!-- Submit input -->
		<!--
		<input type="submit" value="Pay Now">
		-->

		<p class="footnote">
			The Polytechnic University of Bari and De Componendis Cifris kindly request your consent for the
			processing
			of your personal data provided in the following payment form. This information is passed from De
			Componendis
			Cifris to the University ASAP and it is immediately deleted by De Componendis Cifris afterwards. The
			University declares that this information is essential for event planning, communication purposes, and
			addressing any special requests. Your personal data will be securely deleted upon the conclusion of the
			event. Learn more here about how the Polytechnic University of Bari adheres to GDPR regulations in
			handling
			personal data and about your rights. <br>
			<a href="https://www.poliba.it/it/privacy/note-informative-sulla-privacy">
				poliba.it/it/privacy/note-informative-sulla-privacy
			</a>
		</p>
		<p class="footnote">
			By filling the above form you confirm that you have reviewed how the Polytechnic University of Bari
			processes your personal data as outlined there and provide your consent for such processing.
		</p>
	</form>
</div>